import { render, staticRenderFns } from "./SkuChooseTab.vue?vue&type=template&id=7142fbf4&scoped=true&"
import script from "./SkuChooseTab.vue?vue&type=script&lang=js&"
export * from "./SkuChooseTab.vue?vue&type=script&lang=js&"
import style0 from "./SkuChooseTab.vue?vue&type=style&index=0&id=7142fbf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142fbf4",
  null
  
)

export default component.exports